<app-spinner-service></app-spinner-service>

<app-toolbar-search (onSearch)="applyFilterGlobal($event)" placeholder="Pesquise por descrições padrão...">
  <div leftContent>
    <button pButton label="Adicionar Descrição" icon="pi pi-plus" (click)="openNew()" class="add-button"></button>
  </div>
</app-toolbar-search>

<p-table #dt 
  [value]="descricaoPadrao" 
  [paginator]="true" 
  [rows]="10" 
  [globalFilterFields]="['descricao', 'detalhes']"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table" 
  [loading]="loading" 
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">
  
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="descricao" style="width: 40%">
        Descrição <p-sortIcon field="descricao"></p-sortIcon>
      </th>
      <th pSortableColumn="detalhes" style="width: 40%">
        Detalhes <p-sortIcon field="detalhes"></p-sortIcon>
      </th>
      <th style="width: 20%; text-align: center;">Ações</th>
    </tr>
  </ng-template>
  
  <ng-template pTemplate="body" let-descricaoPadrao>
    <tr>
      <td>
        <div class="descricao-content">
          <i class="pi pi-align-left descricao-icon"></i>
          <span class="descricao-text" [pTooltip]="descricaoPadrao.descricao" tooltipPosition="top">{{ajustaTamanhoCampo(descricaoPadrao.descricao)}}</span>
        </div>
      </td>
      <td>
        <div class="detalhes-content">
          <i class="pi pi-info-circle detalhes-icon"></i>
          <span class="detalhes-text" [pTooltip]="descricaoPadrao.detalhes" tooltipPosition="top">{{ajustaTamanhoCampoDetalhes(descricaoPadrao.detalhes)}}</span>
        </div>
      </td>
      <td class="text-center">
        <div class="actions-content">
          <button pButton
            icon="pi pi-eye"
            class="p-button-rounded p-button-info action-button"
            (click)="viewDetails(descricaoPadrao)"
            pTooltip="Ver Detalhes"
            tooltipPosition="top">
          </button>
          <button pButton
            icon="pi pi-pencil"
            class="p-button-rounded p-button-warning action-button"
            (click)="editDescricaoPadrao(descricaoPadrao.id)"
            pTooltip="Editar Descrição"
            tooltipPosition="top">
          </button>
          <button pButton
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger action-button"
            (click)="deleteDescricaoPadrao(descricaoPadrao)"
            pTooltip="Excluir Descrição"
            tooltipPosition="top">
          </button>
        </div>
      </td>
    </tr>
  </ng-template>
  
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-file-text" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhuma descrição encontrada</h3>
          <p>Não há descrições padrão cadastradas no sistema.</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>
<p-dialog
  [(visible)]="detailsDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  header="Detalhes da Descrição Padrão"
  styleClass="app-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '900px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
  <div class="dialog-content-wrapper" *ngIf="selectedDescricaoPadrao">
    <div class="detail-card">
      <div class="detail-header">
        <div class="header-icon"><i class="pi pi-file-edit"></i></div>
        <div class="header-info">
          <h2 class="detail-title">{{ selectedDescricaoPadrao.descricao }}</h2>
          <p class="detail-subtitle">Descrição Padrão</p>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title"><i class="pi pi-info-circle"></i><span>Conteúdo</span></div>
        <div class="detail-grid">
          <div class="detail-item full-width">
            <div class="detail-label"><i class="pi pi-align-left"></i><span>Descrição</span></div>
            <div class="detail-value">{{ selectedDescricaoPadrao.descricao }}</div>
          </div>
          <div class="detail-item full-width">
            <div class="detail-label"><i class="pi pi-info-circle"></i><span>Detalhes</span></div>
            <div class="detail-value">
              <span *ngIf="selectedDescricaoPadrao.detalhes" class="detalhes-text">{{ selectedDescricaoPadrao.detalhes }}</span>
              <span *ngIf="!selectedDescricaoPadrao.detalhes" class="no-data">Não informado</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-secondary" (click)="detailsDialogVisible = false"></button>
  </ng-template>
</p-dialog>
